import React from 'react'
import CartListReport from '../../../components/CardListReport/CartListReport'
import { Translate } from '../../../language'
import style from "./ReportedContentList.module.css"
const ReportContentList = ({ listOfReports,changeReport }) => {
    return (
        <div>
            <div className={style.report_container}>
                {
                    listOfReports.map(report => (
                        <CartListReport
                            options={[
                                {
                                    text: Translate("accept", "es"),
                                    onClick: (e) => {
                                        e.stopPropagation();
                                        //     history.push("/PersonalInfo");
                                        changeReport(5,report._id,)

                                     
                                    }
                                },
                                {
                                    text: Translate("reject", "es"),
                                    onClick: (e) => {
                                        e.stopPropagation();
                                        changeReport(4,report._id)
                                      
                                    }
                                }
                            ]}
                            descriptions={report.descriptions}
                            typeOfReportsIDS={report.typeOfReportsIDS}
                            type={report.contentType}
                            post={report.postID}
                            comment={report.commentID}


                            key={report._id}

                            textTwo={`Reportado por ${report.typeOfReportsIDS.length > 0 ? report.typeOfReportsIDS[0].description : report.descriptions[0].message}`}
                        />
                    ))


                }
            </div>
        </div>
    )
}

export default ReportContentList